import Swiper from 'swiper';

class HomeSlider {

  constructor(){
    this.component = document.querySelector('[data-component="home-slider"]');
    this.trigger = document.querySelector('[data-trigger="home-slider"]');
    this._init();
  }

  _init(){
    
    if( this.component ){
      let swiper = null;
        
      // If swiper is init before image is loaded, we reload swiper
      // (when lazyload images with data-visibility)
      const firstImage = this.trigger.querySelector('img');
      if(firstImage){
        firstImage.onload = ()=> {
          if(swiper){
            swiper.update();
          }
        };
      }


      swiper = new Swiper(this.trigger, {
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: this.component.querySelector('[data-trigger="home-slider-pagination"]'),
          type: 'bullets',
          clickable: true
        },
        preloadImages: false,
        lazy: {
          loadOnTransitionStart: true,
        },
        effect:'fade',
        fadeEffect: {
          crossFade: true
        },
      });
    }
  }

}

export const homeSlider = new HomeSlider();